<!-- App Error Boundary: shown when non-caught errors occur, shows a notification toast. -->
<template>
  <slot />
</template>

<script setup lang="ts">
import {useNotification} from '@myparcel-frontend/notifications';
import {onErrorCaptured} from 'vue';
import {useI18n} from 'vue-i18n';
import logToMonitor from '@/utils/logging';

const {t} = useI18n();
const {addNotification} = useNotification();

onErrorCaptured((error: Error) => {
  const NOTIFICATION_TIMEOUT = 6000;
  addNotification({
    variant: 'alert',
    title: `${t('errors.general')}:`,
    body: error.toString(),
    timeout: NOTIFICATION_TIMEOUT,
  });

  logToMonitor(error, {
    _myparcel_extra_info: 'Unhandled error captured by AppErrorBoundary component',
    _myparcel_boundary: 'App',
    _myparcel_route: window.location?.pathname,
  });

  // do not propagate upwards to the root error boundary:
  return false;
});
</script>
